"use strict";
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var m = require("mithril");
var update_visualisation_1 = require("./update_visualisation");
var utils_1 = require("./utils");
var simulation_1 = require("./simulation");
var Visualisation = {
    oncreate: function (_a) {
        var _b = _a.attrs, focused = _b.focused, title = _b.title, forceSimulation = _b.forceSimulation, dom = _a.dom;
        update_visualisation_1.updateVisualisation(dom, focused, title, forceSimulation, true);
        _this.oldFocused = focused;
    },
    onupdate: function (_a) {
        var _b = _a.attrs, focused = _b.focused, title = _b.title, forceSimulation = _b.forceSimulation, dom = _a.dom;
        var focusedUpdated = focused !== _this.oldFocused;
        update_visualisation_1.updateVisualisation(dom, focused, title, forceSimulation, focusedUpdated);
        _this.oldFocused = focused;
    },
    view: function (_a) {
        var focused = _a.attrs.focused;
        return m('svg', {
            version: '1',
            xmlns: 'http://www.w3.org/2000/svg',
        });
    },
};
window.addEventListener('resize', function () {
    m.redraw();
});
m.mount(document.body, {
    view: function () {
        return m(Visualisation, {
            focused: utils_1.focusedType(),
            title: utils_1.visualisationTitle(utils_1.hoveredNode(), utils_1.focusedType()),
            forceSimulation: simulation_1.forceSimulation,
        });
    }
});
//# sourceMappingURL=index.js.map